module.exports = __webpack_public_path__ + "media/images/flags/1x1/kna-2daab0f01b274f2f767f5a4c96798cb4.svg";